export const matterportModalTitle = 'Service Matterport';
export const editMatterportModalTitle = 'Sync a Matterport';
export const editMatterportModalDescription = 'Add a Matterport scan to this listing, by pasting the link below.';
export const editMatterportModalLabel = 'Add Matterport to this service';
export const editMatterportModalPlaceholder = 'Matterport model id or Matterport link...';
export const matterportLabel = 'matterport';
export const matterportButton = 'View Matterport';
export const noMatterport = 'No matterport';
